import { typologyLabel } from "@/lib/customTypologies";
import { useLogo, LOGO_RATIO } from "@/lib/brand";

export const F = "helvetica";

const Row = ({ y, label, value, h = 9 }) => (
  <g>
    <line x1={305} y1={y} x2={410} y2={y} stroke="#000" strokeWidth={0.25} />
    <text x={307} y={y + 3.2} fontSize={2.2} fill="#555" fontFamily={F}>{label.toUpperCase()}</text>
    <text x={307} y={y + h - 2} fontSize={3.1} fill="#000" fontFamily={F}>{String(value || "—").slice(0, 52)}</text>
  </g>
);

const Logo = () => {
  const src = useLogo(), w = 98;
  return (
    <g data-testid="sheet-logo">
      <line x1={305} y1={168} x2={410} y2={168} stroke="#000" strokeWidth={0.25} />
      <text x={307} y={172.5} fontSize={2.2} fill="#555" fontFamily={F}>DESIGNED &amp; DETAILED BY</text>
      <image href={src} x={306} y={176} width={w} height={w / LOGO_RATIO} preserveAspectRatio="xMinYMid meet" data-logo="1" />
    </g>
  );
};

export const SheetFrame = ({ svgRef, item, tb, sheetNo, total, suffix, kind, title, subtitle, scaleText, scaleValue = 1, rows: customRows, children }) => {
  const rows = customRows || [
    ["Project", tb.project_name], ["Client", tb.client], ["Architect / Consultant", tb.architect], ["Fabricator / Contractor", tb.contractor || tb.company],
    ["Item", `${item.tag} — ${item.name || item.type}`], ["Location / Qty", `${item.location || "—"}  ·  Qty ${item.quantity || 1}`],
    ["Typology", `${typologyLabel(item.typology)}${item.source_typology ? ` (from: ${item.source_typology})` : ""}`],
    ["Overall size (W × H)", `${item.width} × ${item.height} mm`], ["Aluminium system", `${item.profile_system || ""}${item.interlock ? ` · ${item.interlock}-type interlock` : ""}${item.railing?.height ? ` · railing ${item.railing.height}` : ""}`],
    ["Face widths frame / mullion / sash", `${item.frame_width} / ${item.mullion_width} / ${item.sash_width} mm · depth ${item.frame_depth || 60}`], ["Glazing", item.glass_spec],
    ["Finish", item.finish], ["Hardware", item.hardware],
  ];
  return (
    <svg ref={svgRef} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 420 297" width="420mm" height="297mm" data-scale={scaleValue} data-sheet={`${item.tag}-${suffix}`}>
      <rect x={0} y={0} width={420} height={297} fill="#fff" />
      <rect x={10} y={10} width={400} height={277} fill="none" stroke="#000" strokeWidth={0.6} />
      <line x1={300} y1={10} x2={300} y2={287} stroke="#000" strokeWidth={0.5} />
      <text x={16} y={20} fontSize={5} fontFamily={F} fill="#000" fontWeight="bold">{`${item.tag}  ${title}`}</text>
      <text x={16} y={25.5} fontSize={2.6} fontFamily={F} fill="#555">{subtitle}</text>
      {children}
      <rect x={300} y={10} width={110} height={18} fill="#0E7490" />
      <text x={305} y={19} fontSize={5} fontFamily={F} fill="#fff" fontWeight="bold">{(tb.company || (tb.hide_logo ? "ALUMINIUM SYSTEMS" : "ARTISAN GUILD INFRA")).slice(0, 30)}</text>
      <text x={305} y={24.5} fontSize={2.5} fontFamily={F} fill="#E0F2FE">{kind}</text>
      {rows.map(([l, v], i) => <Row key={l} y={30 + i * 8.6} label={l} value={v} h={8.6} />)}
      <Row y={142} label="Notes" value={item.notes || tb.notes} h={22} />
      {!tb.hide_logo && <Logo />}
      <g>
        {[["Scale", scaleText], ["Drawing no.", `${tb.drawing_no || "ALU"}-${String(sheetNo).padStart(2, "0")}${suffix}`], ["Sheet", `${sheetNo} of ${total}`], ["Revision", tb.revision], ["Date", tb.date], ["Drawn / Checked", `${tb.drawn_by || "—"} / ${tb.checked_by || "—"}`]].map(([l, v], i) => (
          <g key={l}>
            <rect x={305 + (i % 2) * 52.5} y={222 + Math.floor(i / 2) * 18} width={52.5} height={18} fill="none" stroke="#000" strokeWidth={0.25} />
            <text x={307 + (i % 2) * 52.5} y={226 + Math.floor(i / 2) * 18} fontSize={2.2} fill="#555" fontFamily={F}>{l.toUpperCase()}</text>
            <text x={307 + (i % 2) * 52.5} y={235 + Math.floor(i / 2) * 18} fontSize={3.6} fill="#000" fontFamily={F} fontWeight="bold">{String(v || "—").slice(0, 24)}</text>
          </g>
        ))}
      </g>
    </svg>
  );
};
